import axios from 'axios';

export async function getProducts(filter) {
  const response = await axios.post(`${process.env.VUE_APP_API_HOST}wp-json/eemax/search_products`, filter);
  return response.data;
}

export async function getLocationsWithTemp() {
  const response = await axios.get(`${process.env.VUE_APP_API_HOST}wp-json/groundwater_temp/get_temp_locations`);
  return response.data;
}

export async function getClosestLocation(zipCode) {
  const response = await axios.get(`${process.env.VUE_APP_API_HOST}wp-json/groundwater_temp/get_closest_temp_location/${zipCode}`);
  return response.data;
}
